import { render, staticRenderFns } from "./nutrition-result.vue?vue&type=template&id=18e17d85&scoped=true"
import script from "./nutrition-result.vue?vue&type=script&lang=js"
export * from "./nutrition-result.vue?vue&type=script&lang=js"
import style0 from "./nutrition-result.vue?vue&type=style&index=0&id=18e17d85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e17d85",
  null
  
)

export default component.exports